import React, { useEffect, useState } from "react";
import { Card, Table, Form } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
const EmployeeAttendance = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [localSortBy, setLocalSortBy] = useState("Recently Added");
  const attendanceData = [
    {
      name: "Anthony Lewis",
      dept: "Finance",
      avatar: "/assets/img/users/user-32-1.jpg",
      date: "14 Jan 2024",
      checkIn: "09:32 AM",
      status: "Present",
      checkOut: "06:45 PM",
      break: "30 Min",
      late: "32 Min",
      overtime: "20 Min",
      hours: "8.55",
      color: "success",
    },
    {
      name: "Brian Villalobos",
      dept: "Developer",
      avatar: "/assets/img/users/user-09.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "06:12 PM",
      break: "20 Min",
      late: "-",
      overtime: "45 Min",
      hours: "7.54",
      color: "danger",
    },
    {
      name: "Connie Waters",
      dept: "Developer",
      avatar: "/assets/img/users/user-01-1.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "08:15 PM",
      break: "12 Min",
      late: "-",
      overtime: "-",
      hours: "8.35",
      color: "success",
    },
    {
      name: "Doglas Martini",
      dept: "Manager",
      avatar: "/assets/img/users/user-33-1.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "06:43 PM",
      break: "23 Min",
      late: "-",
      overtime: "10 Min",
      hours: "8.22",
      color: "success",
    },
    {
      name: "Elliot Murray",
      dept: "Finance",
      avatar: "/assets/img/users/user-02.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "07:13 PM",
      break: "32 Min",
      late: "-",
      overtime: "-",
      hours: "9.15",
      color: "info",
    },
    {
      name: "Harvey Smith",
      dept: "Developer",
      avatar: "/assets/img/users/user-01-1.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "06:13 PM",
      break: "50 Min",
      late: "-",
      overtime: "33 Min",
      hours: "8.45",
      color: "success",
    },
    {
      name: "Linda Ray",
      dept: "Finance",
      avatar: "/assets/img/users/user-02.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "07:15 PM",
      break: "03 Min",
      late: "-",
      overtime: "-",
      hours: "8.32",
      color: "success",
    },
    {
      name: "Lori Broaddus",
      dept: "Developer",
      avatar: "/assets/img/users/user-38.jpg",
      date: "14 Jan 2024",
      checkIn: "-",
      status: "Absent",
      checkOut: "-",
      break: "-",
      late: "-",
      overtime: "-",
      hours: "0.00",
      color: "danger",
    },
    {
      name: "Rebecca Smith",
      dept: "Executive",
      avatar: "/assets/img/users/user-36.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "09:17 PM",
      break: "14 Min",
      late: "12 Min",
      overtime: "-",
      hours: "9.25",
      color: "success",
    },
    {
      name: "Stephan Peralt",
      dept: "Executive Officer",
      avatar: "/assets/img/users/user-33-1.jpg",
      date: "14 Jan 2024",
      checkIn: "09:00 AM",
      status: "Present",
      checkOut: "06:23 PM",
      break: "41 Min",
      late: "-",
      overtime: "50 Min",
      hours: "8.55",
      color: "success",
    },
  ];

  const filteredData = attendanceData.filter((emp) => {
    const matchesSearch = emp.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "All" || emp.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const [selected, setSelected] = useState("Last 7 Days");
  const [dateRange, setDateRange] = useState({
    from: "03/25/2026",
    to: "03/31/2026",
  });

  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

  useEffect(() => {
    const today = new Date();
    let fromDate = new Date(today);
    let toDate = new Date(today);

    switch (selected) {
      case "Today":
        break;
      case "Yesterday":
        fromDate.setDate(today.getDate() - 1);
        toDate = new Date(fromDate);
        break;
      case "Last 7 Days":
        fromDate.setDate(today.getDate() - 6);
        break;
      case "Last 30 Days":
        fromDate.setDate(today.getDate() - 29);
        break;
      case "This Year":
        fromDate = new Date(today.getFullYear(), 0, 1);
        toDate = new Date(today.getFullYear(), 11, 31);
        break;
      case "Next Year":
        fromDate = new Date(today.getFullYear() + 1, 0, 1);
        toDate = new Date(today.getFullYear() + 1, 11, 31);
        break;
      case "Custom Range":
        setDateRange({ from: "", to: "" });
        return;
      default:
        break;
    }

    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };

    setDateRange({ from: formatDate(fromDate), to: formatDate(toDate) });
  }, [selected]);
  return (
    <Card className="shadow-sm border-0   mt-3 ">
      <Card.Header className="bg-white border-bottom py-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <h5 className="mb-0 fw-semibold text-dark">Employee Attendance</h5>

          <div className="d-flex flex-wrap align-items-center gap-2">
            {/* Date Range */}
            <Dropdown>
              {/* TOGGLE (INPUT STYLE EXACT) */}
              <Dropdown.Toggle as="div" className="input-group calendar-box">
                <span className="input-group-text bg-white ">
                  <FiCalendar />
                </span>

                <input
                  type="text"
                  className="form-control border"
                  value={
                    dateRange.from && dateRange.to
                      ? `${dateRange.from} - ${dateRange.to}`
                      : selected
                  }
                  readOnly
                />
              </Dropdown.Toggle>

              {/* DROPDOWN MENU */}
              <Dropdown.Menu className="dropdown-ui p-2">
                {options.map((item, i) => (
                  <Dropdown.Item
                    key={i}
                    onClick={() => setSelected(item)}
                    className={`dropdown-item rounded-1 ${
                      selected === item ? "active-item" : ""
                    }`}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {/* Select Status Dropdown */}
            <Dropdown className="status-dropdown">
              <Dropdown.Toggle as="div" className="status-btn">
                {statusFilter || "Select Status"}
              </Dropdown.Toggle>

              <Dropdown.Menu className="custom-status-menu">
                {["Present", "Absent"].map((item) => (
                  <Dropdown.Item
                    key={item}
                    onClick={() => setStatusFilter(item)}
                    className={statusFilter === item ? "active" : ""}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Sort By Dropdown - Exact as your latest image */}
            <div className="custom-dropdown">
              <Dropdown align="end">
                {/* Toggle Button */}
                <Dropdown.Toggle className="sort-btn bg-transparent text-dark border border-1">
                  Sort By : {localSortBy}
                </Dropdown.Toggle>

                {/* Dropdown Items */}
                <Dropdown.Menu className="custom-menu">
                  {[
                    "Recently Added",
                    "Ascending",
                    "Descending",
                    "Last Month",
                    "Last 7 Days",
                  ].map((value) => (
                    <Dropdown.Item
                      key={value}
                      active={localSortBy === value}
                      onClick={() => setLocalSortBy(value)}
                    >
                      {value}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Card.Header>

      <Card.Body className="p-0">
        {/* Row Per Page + Search Bar - Exact match */}
        <div className="d-flex align-items-center justify-content-between px-3 py-3 border-bottom bg-white">
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted">Row Per Page</span>
            <Form.Select size="sm" style={{ width: "80px" }}>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </Form.Select>
            <span className="text-muted">Entries</span>
          </div>

          <div className="input-group" style={{ width: "240px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className="btn btn-light border">
              <i className="ti ti-search"></i>
            </button>
          </div>
        </div>

        {/* Main Table - Exact Design */}
        <div className="table-responsive">
          <Table hover className="mb-0 align-middle">
            <thead className="bg-light">
              <tr>
                <th className="py-3">Name</th>
                <th className="py-3">Date</th>
                <th className="py-3">Check In</th>
                <th className="py-3">Status</th>
                <th className="py-3">Check Out</th>
                <th className="py-3">Break</th>
                <th className="py-3">Late</th>
                <th className="py-3">Overtime</th>
                <th className="py-3 text-end">Production Hours</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((emp, idx) => (
                <tr key={idx}>
                  <td>
                    <div className="d-flex align-items-center">
                      <img
                        src={emp.avatar}
                        alt={emp.name}
                        className="rounded-circle me-3"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                        }}
                      />
                      <div>
                        <div className="fw-medium">{emp.name}</div>
                        <small className="text-muted">{emp.dept}</small>
                      </div>
                    </div>
                  </td>
                  <td>{emp.date}</td>
                  <td>{emp.checkIn}</td>
                  <td>
                    <span
                      className={`status-badge ${
                        emp.status === "Present" ? "present" : "absent"
                      }`}
                    >
                      <span className="dot"></span>
                      {emp.status}
                    </span>
                  </td>
                  <td>{emp.checkOut}</td>
                  <td>{emp.break}</td>
                  <td>{emp.late}</td>
                  <td>{emp.overtime}</td>
                  <td className="text-end">
                    <span
                      className={`hrs-badge ${
                        emp.hours === "0.00"
                          ? "red"
                          : parseFloat(emp.hours) < 9
                            ? "blue"
                            : "green"
                      }`}
                    >
                      <span className="clock-icon"></span>
                      {emp.hours} Hrs
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
      <style>
        {`
     .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  width: fit-content;
}

/* Green (Present) */
.status-badge.present {
  background-color: #e6f4ea;
  color: #16a34a;
}

/* Red (Absent) */
.status-badge.absent {
  background-color: #fde8e8;
  color: #dc2626;
}

/* Dot */
.status-badge .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

/* Dot colors */
.status-badge.present .dot {
  background-color: #16a34a;
}

.status-badge.absent .dot {
  background-color: #dc2626;
}
  
.hrs-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: #ffffff;
  line-height: 1;
}

/* COLORS EXACT LIKE IMAGE */
.hrs-badge.green {
  background-color: #16a34a;
}

.hrs-badge.red {
  background-color: #e11d1d;
}

.hrs-badge.blue {
  background-color: #2f7ae5;
}

/* CLOCK ICON (PURE CSS - PERFECT MATCH) */
.clock-icon {
  width: 12px;
  height: 12px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  position: relative;
  display: inline-block;
}

/* Hour hand */
.clock-icon::before {
  content: "";
  position: absolute;
  width: 1.5px;
  height: 4px;
  background: #ffffff;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
}

/* Minute hand */
.clock-icon::after {
  content: "";
  position: absolute;
  width: 3px;
  height: 1.5px;
  background: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-10%, -50%);
}
  .calendar-box {
          width: 230px;
          cursor: pointer;
        }

        .calendar-box input {
          cursor: pointer;
          background: #fff;
        }

        .dropdown-ui {
          border-radius: 8px;
          min-width: 200px;
        }

        /* ORANGE ACTIVE */
        .active-item {
          background: #f26522 !important;
          color: #fff !important;
        }

        /* HOVER */
        .dropdown-ui .dropdown-item:hover {
          background: #f26522 !important;
          color: #fff !important;
        }
          /* Container */
.status-dropdown {
  width: 180px;
}

/* Button */
.status-btn {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  padding: 8px 14px;
  font-size: 14px;
  border-radius: 6px;
  color: #111827;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Remove default arrow */
.status-btn::after {
  content: "▾";
  border: none;
  font-size: 12px;
}

/* Dropdown */
.custom-status-menu {
  width: 100%;
  margin-top: 6px;
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

/* Items */
.custom-status-menu .dropdown-item {
  padding: 10px 12px;
  font-size: 14px;
  color: #374151;
  border-radius: 6px;
}

/* Hover */
.custom-status-menu .dropdown-item:hover {
  background-color: #f3f4f6;
}

/* Active (same as image — subtle grey) */
.custom-status-menu .dropdown-item.active {
  background-color: #f3f4f6 !important;
  color: #111827 !important;
  font-weight: 500;
}
     
/* Dropdown background (GREY) */
.custom-menu {
  background-color: #f3f4f6; /* light grey */
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #e5e7eb;
}

/* Items */
.custom-menu .dropdown-item {
  border-radius: 6px;
  padding: 10px 14px;
  color: #374151;
}

/* Hover */
.custom-menu .dropdown-item:hover {
  background-color: #e5e7eb;
}

/* ✅ ACTIVE = ORANGE (IMPORTANT) */
.custom-menu .dropdown-item.active,
.custom-menu .dropdown-item:active {
  background-color: #f26422 !important; /* ORANGE */
  color: #ffffff !important;
}
`}
      </style>
    </Card>
  );
};

export default EmployeeAttendance;
